import { useEffect } from 'react';

type PageMeta = {
  title: string;
  description?: string;
  keywords?: string;
};

const setMeta = (name: string, content: string) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

export function usePageMeta({ title, description, keywords }: PageMeta) {
  useEffect(() => {
    document.title = title;
    if (description) setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);
  }, [title, description, keywords]);
}